import bookCreatorProvider from "@/core/providers/book-creator";
import { observer } from "mobx-react";
import { FC, useEffect, useState } from "react"
import CreatePageSheetWrapper from "./page-create-panel-wrapper";
import { PlusCircleIcon } from "@heroicons/react/24/outline";
//@ts-ignore
import Sortable from "sortablejs";
import bookCreatorPageManager from "@/core/providers/book-creator-page-manager";
import { get_image_thumbnail } from "@/core/utils/utils";
/**
 * 创建书籍的略缩图列表
 */
interface PageThumbnailModel {
    src: string,
    id: number,
}
const PageThumbnailSlider = observer(() => {
    const [thumbnails, setThumbnails] = useState<Array<PageThumbnailModel>>([]);
    const [current, setCurrentThumbnail] = useState<Nullable<PageThumbnailModel>>(null);


    useEffect(() => {
        setThumbnails(bookCreatorProvider.pages.map<PageThumbnailModel>(_ => {
            return {
                src: _.image,
                id: _.index,
            }
        }));
    }, [bookCreatorProvider.count])

    const handleSelectItem = (current: PageThumbnailModel) => {
        setCurrentThumbnail(current);
    }

    useEffect(() => {
        if (thumbnails.length > 0) {
            const el = document.querySelector("#sort-wrap");
            const sortable = new Sortable(el, {
                animation: 300,
                onUpdate: (e: any) => {
                    const order = sortable.toArray().map((_: string) => parseInt(_))
                    bookCreatorProvider.sortByArray(order);
                },
            });
        }
    }, [thumbnails]);

    return <div className="w-full h-full max-h-full overflow-scroll p-2 pr-0">
        <div id="sort-wrap">
            {
                thumbnails.map((_, ndx) => (
                    <div key={ndx} onClick={() => handleSelectItem(_)} data-id={_.id}>
                        <PageThumbnail selected={current?.id === _.id} model={_} page_index={ndx} />
                    </div>
                ))
            }
            <CreatePageSheetWrapper>
                <div className="w-full h-28 flex items-center border border-gray-300 rounded-md justify-center cursor-pointer">
                    {/* <div className="text-gray-300 text-sm">点击新增页面+</div> */}
                    <PlusCircleIcon className="size-8 stroke-info cursor-pointer" title="新建页面" />
                </div>
            </CreatePageSheetWrapper>
        </div>
    </div>
})


// 页面左侧略缩图组件
const PageThumbnail: FC<{
    selected: boolean,
    model: PageThumbnailModel,
    page_index: number,
}> = ({ selected, model, page_index }) => {
    const handleClick = () => {
        bookCreatorPageManager.handleFocusPage(model.id);
    }
    return <div onClick={handleClick} className={`group overflow-hidden relative shadow cursor-pointer border border-primary rounded-sm w-full my-4 transition-all duration-300 ease-in-out ${selected ? 'border-primary' : 'border-transparent'}`}
        style={{
            // opacity: selected ? 1 : 0.5,
        }}>
        <div className="w-full pb-[100%] relative bg-background">
            <div className="absolute top-0 left-0 bg-pink w-full h-full" style={{
                backgroundImage: `url(${get_image_thumbnail(model.src)})`,
                backgroundSize: "contain",
                backgroundPosition:"center center",
                backgroundRepeat:"no-repeat"
            }}>
            {/* <img src={`${model.src}`} alt={model.src} className="w-full" /> */}
            </div>
        </div>
        <div className="absolute w-full bottom-[-100%] left-0 bg-black/30 py px-2 text-right text-white group-hover:bottom-0 transition-all duration-300">
            <span>{page_index+1}</span>
        </div>
    </div>
}

export default PageThumbnailSlider;